var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreGifts = function SvgMoreGifts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#fff",
    fillOpacity: 0.1,
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M9.208 8.682A2.708 2.708 0 0 1 14 6.952a2.708 2.708 0 0 1 4.366 3.189H19a2.29 2.29 0 0 1 2.291 2.291V14.1a1.46 1.46 0 0 1-1.067 1.406c.12 1.521.05 3.054-.209 4.56a2.05 2.05 0 0 1-1.791 1.69l-.763.086c-2.3.257-4.623.257-6.924 0l-.761-.085a2.05 2.05 0 0 1-1.792-1.69 18.4 18.4 0 0 1-.208-4.561 1.46 1.46 0 0 1-1.068-1.406v-1.667A2.29 2.29 0 0 1 9 10.141h.633a2.7 2.7 0 0 1-.425-1.459m4.167 0a1.458 1.458 0 1 0-2.917 0 1.458 1.458 0 0 0 2.917 0m2.708 1.459a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.917m-8.125 2.291c0-.575.467-1.041 1.042-1.041h4.375v2.916H8.166a.21.21 0 0 1-.208-.208zm6.667 3.125h4.349a17.2 17.2 0 0 1-.19 4.297.8.8 0 0 1-.7.66l-.761.085q-1.347.15-2.698.178zm0-1.25h5.208a.21.21 0 0 0 .208-.208v-1.667c0-.575-.466-1.041-1.041-1.041h-4.375zm-1.25 1.25v5.22a30 30 0 0 1-2.699-.178l-.761-.086a.8.8 0 0 1-.7-.658 17.2 17.2 0 0 1-.19-4.298z",
    clipRule: "evenodd"
  })));
};
export default SvgMoreGifts;